"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleBase = void 0;
var StyleBase = (function () {
    function StyleBase(styleName, localizedName, deleted, hidden, semihidden, isDefault, base64EncodedImage, id) {
        this.styleName = styleName;
        this.deleted = deleted;
        this.localizedName = localizedName;
        this.hidden = hidden;
        this.semihidden = semihidden;
        this.isDefault = isDefault;
        this.base64EncodedImage = base64EncodedImage ? base64EncodedImage : null;
        this.id = id;
    }
    StyleBase.prototype.equalsByName = function (obj) {
        return this.styleName == obj.styleName;
    };
    return StyleBase;
}());
exports.StyleBase = StyleBase;
